import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';

import { PrimeIcons } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';

import Config from '../config';

const ExcludeFromFeeds = () => {
    const [rowsCount, setRowsCount] = useState();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: 'id',
        sortOrder: -1,
        filters: {
            'aic': { value: null, matchMode: 'equals' },
            'feed': { value: null, matchMode: 'equals' },
            'title': { value: null, matchMode: 'equals' }
        }
    });
    const [feedSelected, setFeedSelected] = useState('');

    const aicRef = useRef();
    const feedRef = useRef();

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/settings/exclude-from-feeds", lazyParams)
            .then(result => result.data)
            .then(result => {
                setRows(result.data.rows);
                setRowsCount(result.data.count);
                setLoading(false);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }
    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    const feedRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={[
            {name: 'Italia', code: 'IT'},
            {name: 'Europa', code: 'EU'},
            {name: 'Svezia', code: 'SE'},
            {name: 'Germania', code: 'DE'},
            {name: 'Francia', code: 'FR'},
            {name: 'Spagna-Belgio-Portogallo', code: 'ES-BE-PT'},
            {name: 'PromoFarma', code: 'PromoFarma'}
          ]}
          optionLabel="name"
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un feed"
          className="p-column-filter"
        />
    );

    const rowFeed = row => {
        if (row.feed === 'it') {
            return 'Italia';
        }
        else if (row.feed === 'eu') {
            return 'Europa';
        }
        else if (row.feed === 'se') {
            return 'Svezia';
        }
        else if (row.feed === 'de') {
            return 'Germania';
        }
        else if (row.feed === 'fr') {
            return 'Francia';
        }
        else if (row.feed === 'es-be-pt') {
            return 'Spagna-Belgio-Portogallo';
        }
        else if (row.feed === 'PromoFarma') {
            return 'PromoFarma';
        }
        else {
          return '';
        }
    };

    const deleteButton = row => (
        <div className="actions">
            <Button
                icon={PrimeIcons.TRASH}
                className="p-button-rounded p-button-danger"
                onClick={() => deleteRow(row)}
            />
        </div>
    );

    const deleteRow = row => {
        setLoading(true);

        Axios.delete(Config.API_BASE_URL+"/api/settings/exclude-from-feeds/"+row.id)
            .then(() => {
                loadLazyData();
            });
    };

    const addRow = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/settings/add-exclude-from-feeds", { aic: aicRef.current.value, feed: feedSelected })
            .then(() => {
                aicRef.current.value = '';
                feedRef.current.value = '';
                loadLazyData();
            });
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Elenco dei prodotti esclusi dai feed</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={rows}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={rowsCount}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun prodotto trovato."
                    >
                      <Column key="aic" header="AIC" field="aic" filter showFilterMenu={false} style={{ maxWidth: '100px' }} />
                      <Column field="feed" body={rowFeed} filter showFilterMenu={false} filterElement={feedRowFilterTemplate} header="Feed" />
                      <Column key="title" header="Nome" field="title" filter showFilterMenu={false} /*style={{ maxWidth: '100px' }}*/ />
                      <Column body={deleteButton} style={{ maxWidth: '50px' }} />
                    </DataTable>
                </div>

                <div className="card">
                    <h5>Aggiungi un AIC da escludere</h5>
                    <div className="formgroup-inline">
                        <div className="field">
                            <label htmlFor="aic" className="p-sr-only">AIC</label>
                            <InputText ref={aicRef} id="aic" type="text" />
                        </div>
                        <div className="field">
                            <label htmlFor="feed" className="p-sr-only">Feed</label>
                            <Dropdown
                                ref={feedRef}
                                value={feedSelected}
                                onChange={e => setFeedSelected(e.value)}
                                options={[
                                    {name: 'Italia', code: 'it'},
                                    {name: 'Europa', code: 'eu'},
                                    {name: 'Svezia', code: 'se'},
                                    {name: 'Germania', code: 'de'},
                                    {name: 'Francia', code: 'fr'},
                                    {name: 'Spagna-Belgio-Portogallo', code: 'es-be-pt'},
                                    {name: 'PromoFarma', code: 'PromoFarma'}
                                ]}
                                optionLabel="name"
                            />
                        </div>
                        <Button label="Submit" onClick={() => addRow()}></Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ExcludeFromFeeds, comparisonFn);
